import FleetInquiryForm from "@/components/FleetInquiryForm";

const FleetFormPage = () => {
  return <FleetInquiryForm />;
};

export default FleetFormPage;
